import { render, staticRenderFns } from "./TrainingRoomPage.vue?vue&type=template&id=3223b52c&scoped=true"
import script from "./TrainingRoomPage.vue?vue&type=script&lang=ts"
export * from "./TrainingRoomPage.vue?vue&type=script&lang=ts"
import style0 from "./TrainingRoomPage.vue?vue&type=style&index=0&id=3223b52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3223b52c",
  null
  
)

export default component.exports